import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ChipList from '@components-clean/core/chip-list';
import { useUnsavedChangesContext } from '@contexts-clean/unsaved-changes-context';
import { CM2Dataset } from '@interfaces/central-monitoring';
import CmControlsChartObsAndActions from '@pages-clean/risk-assessment/risk-log/sections/childArea/cm-controls/popout/tables/obs-actions';
import { CmControlsChartAssociatedRisks } from '@pages-clean/risk-assessment/risk-log/sections/childArea/cm-controls/popout/tables/risks.grid';
import { RlCmControlsPopouChipValues } from '@pages-clean/risk-assessment/risk-log/sections/childArea/cm-controls/popout/types';
import { cm2Panel_OpraQueries } from '@queries/generated/central-monitoring.generated';

type Props = {
    studyRef: string;
    panelData?: cm2Panel_OpraQueries;
    dataset: CM2Dataset;
};
export const ControlsHubPopoutRisksAndObs = ({ studyRef, panelData, dataset }: Props) => {
    const { t } = useTranslation('ram', {
        keyPrefix: 'riskLog.popOut',
    });
    const { anyComponentHasChanges } = useUnsavedChangesContext();
    const [selectedTab, setSelectedTab] = useState<RlCmControlsPopouChipValues>(RlCmControlsPopouChipValues.Risks);

    return (
        <div className="k-h-full" style={{ height: 'calc(100% - 38px', width: 'calc(100% - 550px' }}>
            <ChipList
                // We use a compound key here to prevent a bug with the focus state of the chiplist causing
                // some rerenders to steal focus from input elements
                key={String(anyComponentHasChanges())}
                data-testid="ram-cm-contols-popup-chip-list"
                data={[
                    {
                        text: t('chipList.risks'),
                        value: RlCmControlsPopouChipValues.Risks,
                    },
                    {
                        text: t('chipList.cmObservations'),
                        value: RlCmControlsPopouChipValues.CmObervations,
                    },
                ]}
                value={selectedTab}
                onChange={(event) => {
                    const selectedChip = event.value as RlCmControlsPopouChipValues;
                    if (selectedChip) {
                        setSelectedTab(selectedChip);
                    }
                }}
                className="mb-10"
            />
            <div className="k-h-full">
                {selectedTab === RlCmControlsPopouChipValues.Risks && (
                    <CmControlsChartAssociatedRisks studyRef={studyRef} panelData={panelData} dataset={dataset} />
                )}
                {selectedTab === RlCmControlsPopouChipValues.CmObervations && (
                    <CmControlsChartObsAndActions studyRef={studyRef} panelData={panelData} dataset={dataset} />
                )}
            </div>
        </div>
    );
};
